import React, {  useMemo, useState } from "react";
import styled from "styled-components";
import { Typography } from "antd";
import { handleTypeText } from "../helper";
// import Loading from "components/Loading";
import CloseIconss from "../../../utils/assets/images/closes.svg";
import WSCorrect from "../../../utils/assets/images/wsCorrect.svg";
import { PlayCircleOutlined } from "@ant-design/icons";

const MultiChoiceType = ({
  currentData,
  activeIndex,
  handleSubmit,
  playSound,
  loading,
  timeSpent,
  consecutiveCorrect,
  setConsecutiveCorrect,
  isCorrect,
  setLoading,
  buttonClickSound,
  preloadedAssets,
  modernImage
}) => {
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isAnswerSubmitted, setIsAnswerSubmitted] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const { imageUrl = "", inAnimation, outAnimation, inSound } = useMemo(() => {
    if (Array.isArray(modernImage) && modernImage.length > 0) {
      const safeIndex = isCorrect % modernImage.length;
      const shuffledImages = [...modernImage];
      for (let i = shuffledImages.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledImages[i], shuffledImages[j]] = [shuffledImages[j], shuffledImages[i]];
      }
      return shuffledImages[safeIndex];
    }
    return {};
  }, [isCorrect, modernImage]);
  const playInSound = (soundFile) => {
    if (soundFile) {
      const audio = preloadedAssets?.sounds[soundFile];
      audio.playbackRate = 1.8;
      audio.loop = false;
      audio.play();
    }
  };

  const onSubmit = (e, element) => {
    setLoading({ type: "submitLesson", value: true });
    e.preventDefault();
    if (disabled) return;

    setSelectedAnswer(element);
    setIsAnswerSubmitted(true);
    if (element?.trim() === currentData?.correct_answer?.trim()) {
      playInSound(inSound);
      setFadeIn(true);

    }
    setDisabled(true);
    setTimeout(() => {
      handleSubmit(e, element);
      setFadeIn(false);
      setSelectedAnswer(null);
      setIsAnswerSubmitted(false);
      setDisabled(false);
      setLoading({ type: "submitLesson", value: false });
    }, 3500);
  };

  // const handleClick = (e, value) => {
  //   handleSubmit(e, value);
  // };

  return (
    <div>
      <QuestionText className="flex items-center">
        {currentData?.question_audio && currentData?.question_audio?.length > 0 && (
          <div
            style={{
              position: "relative",
              display: "inline-block",
              height: 60,
            }}
          >
            <img
              onClick={playSound}
              style={{ height: 60, cursor: "pointer" }}
              src="/assets/images/femaleVoice.svg"
              alt=""
              title=""
            />
            <PlayCircleOutlined
              onClick={playSound}
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: 22,
                color: "#fff",
                cursor: "pointer",
              }}
            />
          </div>
        )}
        <div className="flex items-center gap-10px whiteSpace-noWrap">
          <Typography.Text className="whiteSpace-noWrap" strong>
            {/* {activeIndex === -1 ? activeIndex + 2 : activeIndex + 1}.{" "} */}
            {currentData?.question}
          </Typography.Text>
        </div>
        {fadeIn && (
          <AnimationContainer
            className={`soccerAnimatedImg animate__animated ${
              fadeIn ? inAnimation : outAnimation
            }`}
          >
            {/* <div className="soccerAnimatedImg animate__animated"> */}
            <img src={imageUrl} alt="" className="crop-img-score" />
          </AnimationContainer>
        )}
      </QuestionText>
      <div className="w-full text-center 55" style={{ marginBottom: "10px" }}>
        <Typography.Text strong className="question-type-text">
          {handleTypeText(currentData?.type)}
        </Typography.Text>
      </div>
      <ChoiceContainer>
        {currentData?.options?.map((element, index) => {
          const isCorrectAnswer = element === currentData?.correct_answer;
          const isSelected = element === selectedAnswer;
          const disableHover = isSelected && isAnswerSubmitted;

          let backgroundColor = "#c9eeff";
          let color = "black";

          if (isAnswerSubmitted && isSelected) {
            if (isCorrectAnswer) {
              backgroundColor = "#00d54f";
              color = "#fff";
            } else {
              backgroundColor = "#f9b8d7";
              color = "black";
            }
          }

          const icon =
            isAnswerSubmitted && isSelected ? (
              isCorrectAnswer ? (
                <img
                  style={{
                    top:"0px",
                    position: "absolute",
                    right: "-25px",
                    width: "72px",
                  }}
                  src={WSCorrect}
                  alt="Correct answer"
                  title="Correct answer"
                />
              ) : (
                <img
                  style={{
                    top:"0px",
                    position: "absolute",
                    right: "-25px",
                    width: "72px",
                  }}
                  src={CloseIconss}
                  alt="Incorrect answer"
                  title="Incorrect answer"
                />
              )
            ) : null;

          return (
            <StyledButton
              className="setbtnColors"
              key={index}
              onClick={(e) => {
                buttonClickSound(isCorrectAnswer);
                onSubmit(e, element)
              }}
              disabled={disabled}
              style={{ backgroundColor, color }}
              $disableHover={disableHover}
            >
              <span>{element}</span>
              {icon}
            </StyledButton>
          );
        })}
      </ChoiceContainer>
    </div>
  );
};

export default MultiChoiceType;

const ChoiceContainer = styled.span`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const AnimationContainer = styled.div`
  position:absolute;
  @media Screen and (max-width:1366px){
    top:35%;
    left:20%;
  }
  @media Screen and (max-width:600px){
      img{
        width:180%;
      }
    }
`;

const QuestionText = styled.p`
  font-size: 16px;
  color: #333;
`;

// const TranslateText = styled.p`
//   font-size: 16px;
//   color: darkblue;
//   font-weight: bold;
//   text-align: center;
//   text-transform: ${(p) => (p?.uppercase ? "uppercase" : "")};
// `;

const StyledButton = styled.button`
  position: relative;
  padding: 10px 24px;
  font-size: 16px;
  border-radius: 20px !important;
  text-transform: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: none;
  width: 100%;
  min-height: 45px;
  margin-bottom: 20px;
  transition: background-color 0.3s ease, color 0.3s ease;

`;

// const StyledButton = styled(Button)`
//   background-color: ${(p) =>
//     p.backgroundColor
//       ? p.backgroundColor
//       : p.isCorrect
//       ? "rgb(180, 255, 219) !important"
//       : "#f9b8d7 !important"};
//   padding: 10px 24px;
//   font-size: 16px;
//   border-radius: 20px;
//   color: ${(p) => (p.color ? p.color : "black")};
//   text-transform: none;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
//   border: none;
//   width: 100%;
//   height: 45px;
//   border-radius: 20px !important;
//   margin-bottom: 20px;
//   &:hover {
//     background-color: #1b85e5 !important;
//   }
// `;
